import { useState } from 'react'
import type { AppNotification } from '@fellowship/shared'
import { useMarkAllRead, useMarkNotificationRead } from '../../../hooks/useNotifications'
import { NotificationRow, FILTER_MATCH, type NotificationFilterKey } from '../NotificationRow'
import { NotificationFilters } from '../NotificationFilters'

interface NotificationsTabProps {
  notifications: AppNotification[]
  unreadCount: number
  isLoading: boolean
}

export function NotificationsTab({ notifications, unreadCount, isLoading }: NotificationsTabProps) {
  const [filter, setFilter] = useState<NotificationFilterKey>('all')
  const markAll = useMarkAllRead()
  const markRead = useMarkNotificationRead()
  const filtered = notifications.filter(FILTER_MATCH[filter])

  return (
    <div style={{ maxWidth: 680 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <NotificationFilters value={filter} onChange={setFilter} unreadCount={unreadCount} />
        {unreadCount > 0 && (
          <button
            onClick={() => markAll.mutate()}
            disabled={markAll.isPending}
            style={{ background: 'none', border: 'none', color: 'var(--primary)', fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', padding: 0, marginLeft: 'auto' }}
          >
            Mark all read
          </button>
        )}
      </div>

      {isLoading && <p style={{ fontSize: 13, color: 'var(--muted)' }}>Loading…</p>}

      {!isLoading && filtered.length === 0 && (
        <div style={{ padding: '48px 0', textAlign: 'center', color: 'var(--muted)', fontSize: 14 }}>
          {filter === 'all' ? 'No notifications yet.' : 'No notifications in this category.'}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {filtered.map((n) => (
          <NotificationRow key={n.id} n={n} onRead={(id) => markRead.mutate(id)} />
        ))}
      </div>
    </div>
  )
}
